import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';
import { Header } from '../Header';
import { Footer } from '../Footer';
//import Receipt from "./Receipt";
//import Document from "./Document";

export default class MyReceipts extends Base {
    constructor(props) {
        super(props);
        this.state = {
            controllerName: 'receipt',
            caller: props.Caller,
            type: props.Type,
            data: null,
            loading: true,
            filters: {
                type: 2,
                buildingId: this.getDefaultGuid(),
            },
            systemModuleId: 29,
            moduleAccessStatus: 1,
            page: 1,
            per_page: 30,
            phrase: ''
        };
        this.keyDownFunction = this.keyDownFunction.bind(this);
    }
    componentWillUnmount() {
        this.removeKeyDown();
    }
    componentDidMount() {
        this.httpPost("api/v1/common/check/module/access", {
            systemModuleId: this.state.systemModuleId
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                this.state.moduleAccessStatus = data.status;

                this.refreshData();
            });
    }
    componentWillReceiveProps(props) {
        if (props.Type == this.state.filters.type) return;
        this.state.filters.type = props.Type;
        this.refreshData();
    }
    //onEdit(id, source) {
    //    this.removeKeyDown();
    //    this.showComponents({ component: <Receipt Source={source} Caller={this} Id={id} /> });
    //}
    //onAdd(type) {
    //    this.removeKeyDown();
    //    this.showComponents({ component: <Receipt Source={1} Type={type} Caller={this} /> });
    //}
    //showDocument(id) {
    //    this.showComponents({ component: <Document Caller={this} Id={id} /> });
    //}
    renderForm() {
        if (this.state.moduleAccessStatus <= 0) return this.renderSystemModuleModuleAccessMessage(this.state.moduleAccessStatus);

        return <div>
            <div className="nk-content-body">
                <div className="nk-block-head nk-block-head-sm">
                    <div className="nk-block-between">
                        <div className="nk-block-head-content">
                            <h3 className="nk-block-title page-title">فهرست پرداختهای من</h3>
                            <div className="nk-block-des text-soft">
                                <p>{this.money(this.state.data.recordsCount)} پرداخت یافت شد</p>
                            </div>
                        </div>
                        <div className="nk-block-head-content">
                            <div className="toggle-wrap nk-block-tools-toggle">
                                <a href="#" className="btn btn-icon btn-trigger toggle-expand me-n1" data-target="pageMenu"><em className="icon ni ni-menu-alt-r"></em></a>
                                <div className="toggle-expand-content" data-content="pageMenu">
                                    <ul className="nk-block-tools g-3">
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="nk-block">
                    <div className="card card-bordered card-stretch">
                        <div className="card-inner-group">
                            <div className="card-inner position-relative card-tools-toggle">
                                <div className="card-title-group">
                                    <form className="card-tools" mthod="post" onSubmit={e => this.refreshData(e)}>
                                        <div className="form-inline flex-nowrap gx-3">
                                            <div className="form-wrap">
                                                <input type="text" defaultValue={this.state.phrase} onChange={e => this.state.phrase = e.target.value} placeholder="توضیحات" className="form-control" />
                                            </div>
                                            <div className="btn-wrap">
                                                <span className="d-none d-md-block"><button onClick={e => this.refreshData(e)} type="submit" className="btn btn-dim btn-outline-light hand"><em class="icon ni ni-search"></em> جستجو</button></span>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                            {this.state.data.recordsCount <= 0 ?
                                <div className="card-inner-group">
                                    <div className="example-alert">
                                        <div className="alert alert-pro alert-warning">
                                            <div className="alert-text">
                                                <h6>توجه</h6>
                                                <p>هیچ پرداختی یافت نشد</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                :
                                <div className="card-inner p-0">
                                    <div className="nk-tb-list nk-tb-ulist">
                                        <div className="nk-tb-item nk-tb-head">
                                            <div className="nk-tb-col text-center"><span className="sub-text">ساختمان</span></div>
                                            <div className="nk-tb-col text-center"><span className="sub-text">واحد</span></div>
                                            <div className="nk-tb-col text-center"><span className="sub-text">شرح صورتحساب</span></div>
                                            <div className="nk-tb-col text-center"><span className="sub-text">مبلغ</span></div>
                                            <div className="nk-tb-col text-center"><span className="sub-text">تاریخ صورتحساب</span></div>
                                            <div className="nk-tb-col text-center"><span className="sub-text">تاریخ پرداخت</span></div>
                                        </div>
                                        {this.state.data.records.map((record, index) =>
                                            <div className="nk-tb-item">
                                                <div className="nk-tb-col">
                                                    <span className="sub-text text-center">{record.buildingTitle}</span>
                                                </div>
                                                <div className="nk-tb-col">
                                                    <span className="sub-text text-center">{record.buildingUnitTitle}</span>
                                                </div>
                                                <div className="nk-tb-col">
                                                    <span className="sub-text text-center">
                                                            {record.description}
                                                    </span>
                                                </div>
                                                <div className="nk-tb-col">
                                                    <span className="sub-text text-center">{this.money(record.total)}</span>
                                                </div>
                                                <div className="nk-tb-col">
                                                    <span className="sub-text text-center">{record.dateString}</span>
                                                </div>
                                                <div className="nk-tb-col">
                                                    <span className="sub-text text-center">{record.dateString}</span>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            }
                            {this.createPaging()}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                <Header data={this.state.data} />,
                <div className="nk-content ">
                    <div className="container-fluid">
                        <div className="nk-content-inner">
                            {this.renderForm()}
                        </div>
                    </div>
                </div>,
                this.renderPopupComponent(),
                <Footer />
            ];
        return contents;
    }
}